import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { FundingRequestEditForm } from '../../../fundingRequests/[fundingRequestId]/FundingRequestEditForm';
import { NavigationSideBar } from '../../NavigationSidebar';
import { ReviewHeaderBar } from '../../ReviewHeaderBar';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { dashboardRoutePadding } from '~/packages/common-frontend/constants';

// Types
const RouteParamsStruct = z.object({
  loanId: z.string({ message: 'Missing URL parameter' }),
  fundingRequestId: z.string({ message: 'Missing URL parameter' }),
});

const RouteBase = () => {
  const params = useParams();
  const { fundingRequestId } = RouteParamsStruct.parse(params);

  return (
    <Flex w="100%">
      <NavigationSideBar />
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        gap="2rem"
        padding={dashboardRoutePadding}
      >
        <ReviewHeaderBar />

        <Typography variant="page-title" trim>
          Review Changes
        </Typography>
        <Typography variant="base-muted">
          Use the left navigation to review edits, which are shown by default.
          Hover over modified fields to see previous values. Use ‘Mark as
          Reviewed’ to track progress; it is not required to submit for
          approval. Select ‘Submit for Approval’ or ‘Return to Editing’ to make
          additional changes.
        </Typography>

        <FundingRequestEditForm fundingRequestId={fundingRequestId} readOnly />
      </Flex>
    </Flex>
  );
};

export const Route = () => {
  const params = useParams();
  const { loanId } = RouteParamsStruct.parse(params);

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to={`/loans/${loanId}/edit`} />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
